<template>
    <div id="infinite-pass-component" />
</template>

<script>
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
import Vue from 'vue';
import { Toast } from 'vant';
import Cookies from 'js-cookie';
import Logs from '@/lib/logs';
import { getUrlKey } from '@/lib/utils';
import { TencentLangList, RegionId } from '@/enums';
import { getDN2TransferStatus } from '@/api/transfer';
import { LiPassConfig } from '../config';

Vue.use(Toast);

export default {
    data() {
        return {
            passInstance: null,
            config: {},
            form: {},
            logs: { web_pageid: 'ghome-web-dn2-lipass' },
        };
    },
    created() {
        const {
            params: { region },
            query: { platform, appId },
        } = this.$route;
        if (!platform) this.$toast('No platform parameter');
        if (!appId) this.$toast('No appId parameter');

        Logs.imgLog_PageLoad({
            ...this.logs,
            web_ext_json: `region=${region}`,
        });

        this.config = LiPassConfig[region];
        this.form = {
            appId,
            platform,
            regionId: RegionId[region],
        };

        if (window.PassFactory) {
            this.passInstance = new window.PassFactory.Pass({
                ...this.config,
                config: {
                    socialList: ['facebook', 'google'],
                    isMobile: true,
                    langType: this.setLang(),
                    loginWithCode: { enable: true, registerType: 'disabled' }, // 只要登录功能，不要注册
                    loginWithPwd: { enable: true, registerType: 'disabled' },
                },
            });
            this.passInstance.start('#infinite-pass-component');
            this.passInstance.on('onLogin', this.onLogin);
        }
    },
    beforeDestroy() {
        this.passInstance && this.passInstance.unmount();
    },
    methods: {
        setLang() {
            let lang = (getUrlKey('lang') || Cookies.get('language') || 'en').toLowerCase();

            // lang 格式的兼容处理
            if (['zh', 'zh-cn'].includes(lang) || /^zh-hans-/.test(lang)) {
                lang = 'zh-hans';
            } else if (/^zh-hant-/.test(lang)) {
                lang = 'zh-tw';
            }

            return TencentLangList.find(item => lang === item.toLowerCase()) || 'en';
        },
        async onLogin(userInfo) {
            const {
                openid: openId,
                token,
                channel_info: { channelId },
            } = userInfo;
            const { appId, platform, regionId } = this.form;

            Logs.imgLog_Button({
                ...this.logs,
                web_buttonid: 'login',
                web_userid: `lipass_openid=${openId}`,
                web_ext_json: `region=${RegionId[regionId]}`,
            });

            try {
                const { isMigrated } = await getDN2TransferStatus({
                    appId,
                    openId,
                    token,
                    channelId,
                    regionId,
                });

                // prettier-ignore
                Logs.imgLog_Button({
                    ...this.logs,
                    web_buttonid: 'migrated-status',
                    web_userid: `lipass_openid=${openId}`,
                    web_ext_json: `region=${RegionId[regionId]};is_migrated=${isMigrated ? 'true' : 'false'}`,
                });

                if (!isMigrated) {
                    this.$router.push({
                        name: 'transferLogin',
                        query: {
                            appId,
                            platform,
                            openId,
                            token,
                            regionId,
                            gameId: this.config.gameID,
                            channelId,
                        },
                    });
                } else {
                    this.$router.push({
                        name: 'transferResult',
                        query: {
                            regionId,
                            isMigrated: 1,
                            status: 1,
                        },
                    });
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#infinite-pass-component {
    height: 100vh;
    background-color: #17131d;

    /deep/ #level-infinite__pass__wrapper,
    /deep/ .pass-content__wrapper {
        width: unset;
    }
}
</style>
